let syncedUserId: string | null = null;

export const hasStartupSynced = (userId: string): boolean => syncedUserId === userId;
export const markStartupSynced = (userId: string): void => { syncedUserId = userId; };
export const clearStartupSync = (): void => { syncedUserId = null; };
